import { GOOGLE_RATING } from "@/lib/data";

function GoogleLogo({ className = "w-5 h-5" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
        >
            <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
        </svg>
    );
}

function Stars({ rating = 5, className = "w-3.5 h-3.5" }) {
    return (
        <span className="inline-flex items-center gap-0.5 text-[#F4B400]" aria-hidden="true">
            {Array.from({ length: 5 }).map((_, i) => (
                <svg
                    key={i}
                    className={className}
                    viewBox="0 0 20 20"
                    fill={i < Math.round(rating) ? "currentColor" : "none"}
                    stroke="currentColor"
                >
                    <path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.4l-4.94 2.6.94-5.5-4-3.9 5.53-.8L10 1.5z" />
                </svg>
            ))}
        </span>
    );
}

export default function GoogleRatingBadge({
    className = "",
    compact = false,
}) {
    const { rating, count, label, url } = GOOGLE_RATING;
    const content = (
        <>
            <GoogleLogo className={compact ? "w-4 h-4" : "w-5 h-5"} />
            <span className="flex flex-col leading-tight">
                <span className="inline-flex items-center gap-1.5">
                    <span className="font-serif text-brown tabular-nums">
                        {rating.toFixed(1)}
                    </span>
                    <Stars rating={rating} className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} />
                </span>
                {/* pas d'uppercase CSS : évite mismatch accessible name / texte visible */}
                <span className="text-[10px] tracking-[0.12em] text-brown-soft">
                    {count} {label}
                </span>
            </span>
        </>
    );

    const base =
        `inline-flex w-fit max-w-full items-center gap-3 rounded-md border border-line bg-off-white/90 backdrop-blur-sm ${
            compact ? "px-3 py-2" : "px-4 py-2.5"
        } ${className}`;

    if (url) {
        return (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${base} transition-colors hover:border-brown/30`}
            >
                {content}
            </a>
        );
    }

    return <div className={base}>{content}</div>;
}

export { GoogleLogo, Stars };
